module.exports = __webpack_public_path__ + "img/logo-agritest.09862bad.svg";